import { Injectable } from '@angular/core';
import { HttpClient } from 'src/core/common/domain/http/http-client';
import { ApiService } from 'src/core/api/domain/api.service';
import { ApiAccessService } from 'src/core/common/domain/api-access/api-access.service';
import { DeviceRepository } from 'src/core/device/domain/device-repository';

type ApiDeviceRequest = {
  fcm_token: string;
  device_uuid: string;
};

@Injectable({
  providedIn: 'any',
})
export class HttpDeviceRepository extends DeviceRepository {
  constructor(
    private readonly apiAccessService: ApiAccessService,
    private readonly apiService: ApiService,
    private readonly client: HttpClient
  ) {
    super();
  }

  async add(fcmToken: string, deviceUuid: string): Promise<void> {
    await this.send('devices.add', fcmToken, deviceUuid);
  }

  async remove(fcmToken: string, deviceUuid: string): Promise<void> {
    await this.send('devices.remove', fcmToken, deviceUuid);
  }

  private async send(endpoint: string, fcmToken: string, deviceUuid: string): Promise<void> {
    // Device (un)registration must never break the user flow (login/logout), so any
    // error is swallowed here and only logged, following the same approach as gaudi.
    try {
      await this.apiAccessService.renewApiAccessIfNeeded();
      const payload: ApiDeviceRequest = {
        fcm_token: fcmToken,
        device_uuid: deviceUuid,
      };
      await this.client.post(`${this.apiService.baseUrl()}/${endpoint}`, payload, {}, true, true);
    } catch (exception) {
      console.error(`[HttpDeviceRepository] ${endpoint} failed`, exception);
    }
  }
}
